<template>
	<div>
		<header id="head" class="pt-3 pb-3 text-center">
			<img class="logo" width="100" src="https://dev.sozpic.com/firvox-agreement/static/img/logo.png" />
		</header>
		<section class="lightgreen-content border-bottom padding-vertical-content">
			<div class="container">
				<div class="row">
					<div class="col">
						<div v-html="text"></div>

					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>

	import axios from 'axios';

	export default{
		data : function(){
			return {
				urls : {
					
				},

				text : ''
			}
		},

		created : function(){

			this.ini();
		},

		beforeCreate : function(){

		},

		methods : {

			
			ini : function(){

				var url = this.config.base_url + 'api/legal-terms';

				axios.get(url).then( (response) => {

					console.log(response);
					this.text = response.data.data;
				}).catch((error) => {
					console.log("ERROR", error);

					this.not_found = true;
				});
			}
		}
	}


</script>


// WEBPACK FOOTER //
// src/components/LegalTermsComponent.vue